import actions from './actions';

const { changeSystemLocale } = actions;

export default {
  changeSystemLocale,
};
